import InfinitySearch from './../infinity-scroll/infinity-scroll';

export default new class Search {
    constructor() {
        this.searchInput = '.js-search';
        this.searchInputClear = '.js-searchClear';
        this.searchWrap = '.search-input-wrap';

        this.bindEvents();

        this.iLastTimeSearch = 0;
        this.sLastSearch = '';
        this.iPage = 1;
    }

    bindEvents () {
        $(document).on('input', this.searchInput, (e)=> {
            let value = e.target.value,
                dataPage = $(e.target).closest(this.searchWrap).attr('data-page');

            if(value.length >= 3 && value != this.sLastSearch) {
                this.iPage = 1;

                InfinitySearch.setDefaultPage('personal-area-search');
                this.makeRequest(value, dataPage);
            }
        });

        $(document).on('click', this.searchInputClear, (e) => {
            $(e.target).closest(this.searchWrap).find(this.searchInput).val('');
        });

        $(document).on('keydown', this.searchInput, (e) => {
            if(event.keyCode == 13) {
                e.preventDefault();
                return false;
            }
        });
    }

    makeRequest(inputValue, dataPage) {

        this.iLastTimeSearch = new Date().getTime();

        setTimeout(() => {
            let iCurrentTime = new Date().getTime();
            if (iCurrentTime >= this.iLastTimeSearch + 300) {
                this.sLastSearch = inputValue;
                
                let params = this.getAjaxSearchParams(dataPage);
                $.request(params.component, {
                    data: {search: inputValue, page: 1, flags: params.flags},
                    update: params.update,
                    loading: '.js-preloaderOverlay',
                    success: (data) => {
                        if (data.value != this.sLastSearch) {
                            return;
                        }

                        $('.add-offer__commodity-list').html('' + data['product-search-result']);
                    }
                });
            }
        }, 300);
        
        
    }

    getAjaxSearchParams(dataPage) {
        switch (dataPage){
            case 'product-search-result':
                let update = {'product-search-result' : '.add-offer__commodity-list'},
                    component = 'ShopaholicSearch::onAjaxSearch',
                    flags = ['user_filter'];
                return {update: update, component: component, flags: flags};
            default:
                return;
        }
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/text-field/search.js